(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3197],{

/***/ 29063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/facebook-marketplace-badges/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-03-29",
      tag: "Facebook Marketplace",
      title: "Seller Goals: Here Are The 4 Facebook Marketplace Badges You Should Aim To Have",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "On any online marketplace, having a good background\u2013whether as a seller or buyer- matters to freely navigate within the platform and get the most out of the online shopping experience. But this is crucial for sellers as an outstanding profile attracts more customers and closes more sales. This is why there are \"Seller Badges\" on Facebook Marketplace, for instance, which helps the community identify those with good selling history. There are different types of badges, and this guide shares which ones to aim for and how you can earn them."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Types of Badges"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "There are four kinds of badges you can get. You can see this on your account in the Facebook Marketplace when you click the \"Commerce Profile.\" It is usually highlighted in green so anyone can easily see it."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The same goes for anyone who wants to check a seller's badge. While browsing through the photos of the listings, you can click on the seller's profile, and again, you can spot their badge in their account."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Very Responsive"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As the name suggests, sellers with this badge quickly respond to inquiries. This means answering potential buyers' questions on an average of within an hour. Sellers must address at least 80% of all the seller's messages."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The messages can range from a question about an item, the shipping address, an attempt to negotiate a discount, etc. No matter how repetitive it can get, sellers should be patient in answering the inquiries. After all, the buyer may have confused some details, especially if they are not included in your listing."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Consistency is key for you to earn the \"Very Responsive\" badge. However, if you don't have time to keep addressing messages, then you can ask the help of someone, perhaps an assistant, to take over this administrative task for you."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Highly Rated"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This badge is given to sellers who received high ratings on the Facebook Marketplace. The rating should be a consistent four or five stars in the last 30 days\u2013by four or more reviews."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You can access your ratings from your commerce profile. You will get five stars for positive reviews while three stars for negative ones. The actual remarks are as follows: five for \"excellent,\" four for \"good,\" three for \"fair,\" two for \"poor,\" and one for \"very poor.\""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Facebook's new 5-star rating system doesn't allow a public view of reviews anymore unless they are five or more stars. However, if you have old reviews before the new system was implemented, these can be converted into the 5-star score system. This helps you in bumping up your overall commerce profile in the community."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While public reviews are no longer automatic, the rating system still helps manage the community overall and keeps it safe for everyone."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "On Viewing Reviews"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Seller reviews can only be viewed and written through Android phones or iPhones. You can access this on the commerce profile as well and associate it with the individual listing concerned. You can access this once you rate the buyer or after the buyer sends their rating of you after 14 days."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Buyers can write a review about their experience with the seller\u2013from transacting with them, receiving the item they bought to the whole shopping experience. This allows them to air out any positive or negative comments about the individual seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Even if the user didn't complete the transaction, they could still rate the seller, especially if something concerning happened (e.g., harassment, hate language, etc.).", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Buyers can also write a review from a specific listing they purchased from. When they opt to do this, they have the freedom to leave a comment about the product they sold. This is useful, especially when the item is sensitive, like a gadget, a mobile accessory, or other electronics. Of course, you would also want to know if there has been damage in your product that you were unaware of when it was in your possession."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You can reply to the customer, but the latter can no longer do. If they delete their review, they won't be able to post another one about you. The same thing goes if they block you: their review won't be visible to anyone."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Buyers are not allowed to edit, delete, or hide their reviews. This keeps the rating system fair for everyone."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Super Seller"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Available only within Facebook buy-and-sell groups, this badge is given to sellers who frequently post listings. The requirement is at least ten different listings within a specific group in the past 30 days."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Take note there is a difference between Facebook Marketplace and Facebook buy-and-sell (BNS) groups. The former is a large online marketplace where Facebook users can post their listings. It is viewable by the general public, and anyone with an account can interact with your item or product posting."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "On the other hand, the BNS group can be privately owned Facebook groups. This means a certain user can create a group specifically for particular items (e.g., a group for buyers and sellers of secondhand clothes) and can \"lock\" that group. This means no one else can join and/or interact with the group members until the administrator approves of their request to join."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Top Sender"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The badge is given to sellers who could fulfill ten transactions with delivery in a month for at least 60 days. This applies to the previous two months consecutively."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Other requirements include 4.5-star average ratings across 20 or more ratings in all of the orders and the following (in maximum):"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "3% non-buyer cancellation rate"
          }), " - when you or the buyer cancels the order, especially if you weren't able to ship out within seven days"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "1.5% missed handling rate"
          }), " - orders that were canceled more than three days upon its creation"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "1% claim escalation rate"
          }), " - orders with a purchase protection claim that Facebook detected. This happens when the buyer is dissatisfied or when the seller is unresponsive."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "1% chargeback rate"
          }), " - orders that were charged back by the customer via their chosen payment option"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you don't agree with the rating you received, you can escalate a review request to Facebook. But this only applies to cancellations; other appeals such as chargeback, missed handling, and claim escalation are currently not accepted."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You can see your present performance on the Marketplace when you click your profile and then \"Insights.\""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Boosting your Seller Performance"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Having an excellent commerce profile covers several factors beyond quickly responding to inquiries and using the delivery service of Facebook Marketplace."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Among the most effective ways to quickly earn those Facebook badges and close more sales is to cross-list or to cross-promote your products to other top-selling platforms.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop is an app you can use to do this easily. Available on Android and iPhone, the app cross lists, relists, and delists your listings to other sites like Poshmark, Mercari, and soon, even on eBay."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You need not worry about accidentally selling the same item twice on different platforms as OneShop automatically delists once it has been sold."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Within a few clicks, you can gain extensive exposure across hundreds of other potential buyers and close more sales. Seller insights are also available for your reference."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This simple yet efficient app can further guide and train you to improve your overall seller performance and experience.", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/facebook-marketplace-badges.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Seller Goals: Here Are The 4 Facebook Marketplace Badges You Should Aim To Have"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "As a seller, your transaction history can make or break your image and performance in the marketplace. So, your goal is to have a great commerce profile, and here's how badges can help you achieve that."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/facebook-marketplace-badges"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/facebook-marketplace-badges"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Seller Goals: Here Are The 4 Facebook Marketplace Badges You Should Aim To Have"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "As a seller, your transaction history can make or break your image and performance in the marketplace. So, your goal is to have a great commerce profile, and here's how badges can help you achieve that."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "March 29th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "March 29th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Facebook Marketplace"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 86604:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/facebook-marketplace-badges",
      function () {
        return __webpack_require__(29063);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(86604); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);